import { PostMetadata } from "@/components/common/posts/post-metadata";

    export const posts: PostMetadata[] = [
    {
        title: "🎬 Nollywood Meets Côte d’Ivoire : le cinéma nigérian à la découverte de la destination ivoirienne",
        date: "9 – 15 septembre 2026",
        heure: "10:00 am",
        description: "La Côte d’Ivoire accueille une délégation de professionnels de l’industrie cinématographique nigériane dans le cadre de « Nollywood Meets Côte d’Ivoire ».",
        image: "/images/actualites/flash-infos/2026/09/nollywood-meets-cote-divoire/6.jpg",
        slug: "2026/09/nollywood-meets-cote-divoire",
        aLaUne: true,
    },
    {
        title: "👑 Grande finale Reine Awoulaba d’Afrique – Côte d’Ivoire 2026",
        date: "1er août 2026",
        heure: "8:00 pm",
        description: "Le samedi 1er août 2026, le Palais de la Culture d’Abidjan a accueilli la grande finale de la Reine Awoulaba d’Afrique – Côte d’Ivoire 2026.",
        image: "/images/actualites/flash-infos/2026/08/reine-awoulaba-afrique-2026/1.jpg",
        slug: "2026/08/reine-awoulaba-afrique-2026",
        aLaUneSecondaire: true,
    },
    {
        title: "🌳 Côte d’Ivoire Tourisme x WCF – Parc national de Taï 🧡🤍💚",
        date: "11 Novembre 2025",
        heure: "9:35 pm",
        description: "Le 6 novembre 2025, Madame le Directeur Général a reçu le Dr Emmanuel Normand de la WCF, accompagnée de l’équipe technique de l’OIPR.",
        image: "/images/actualites/flash-infos/2025/11/wcf-parc-national-tai/3.jpg",
        slug: "2025/11/wcf-parc-national-tai",
        aLaUneSecondaire: true,
    },
    {
        title: "[MICE] 🧡🤍💚 Intervention remarquable de Malékah Mourad-Conde à San Pedro",
        date: "11 Novembre 2025",
        heure: "9:50 pm",
        description: "Madame le Directeur Général a marqué le symposium par sa vision stratégique et inspirante pour le développement touristique de la Côte d’Ivoire.",
        image: "/images/actualites/flash-infos/2025/11/intervention-maleka-san-pedro/1.jpg",
        slug: "2025/11/intervention-maleka-san-pedro",
        aLaUneSecondaire: true
    },
    {
        title: "🌟 Master Class Inspirante avec Malékah Mourad-Conde à San Pedro 🧡🤍💚",
        date: "24 juin 2024",
        heure: "1:46 am",
        description: "Le 24 septembre 2025, l’auditorium de l’UFR LTHR a accueilli une master class exceptionnelle sur le thème",
        image: "/images/actualites/flash-infos/2025/11/masterclass-malekah/1.JPG",
        slug: "2025/11/masterclass-malekah",
        aLaUneSecondaire: true
    },
    {
        title: "Jacqueville: Montée des Eaux",
        date: "24 juin 2024",
        heure: "1:46 am",
        description: "Ce Mercredi 23 Août, le Directeur de l'Office a rendu visite aux responsables d'établissements hôteliers récemment victimes des eaux montantes. Madame",
        image: "/images/actualites/flash-infos/jacqueville-monntee-eaux/accueil.png",
        slug: "jacqueville-monntee-eaux"
    },
    {
        title: "Haut Conseil des Transporteurs",
        date: "juin 24, 2024",
        heure: "1:22 am",
        description: "Le Directeur Général de Côte d’Ivoire Tourisme a échangé ce Mardi 12 Septembre avec le Haut Conseil du Patronat des Entreprises de Transport Routier. ",
        image: "/images/actualites/flash-infos/haut-conseil-des-transporteurs/accueil.png",
        slug: "haut-conseil-des-transporteurs",
    },
    {
        title: "CHOISEUL AFRICA",
        date: "juin 24, 2024",
        heure: "1:22 am",
        description: "Le Directeur Général de Côte d'Ivoire Tourisme a pris part ce Jeudi 14 Septembre à Abidjan à un séminaire organisé par l’Institut CHOISEUL AFRICA sur les chaînes de valeur durables ",
        image: "/images/actualites/flash-infos/choiseul-africa/accueil.png",
        slug: "choiseul-africa",
    },
    {
        title: "SIAB « Les artisans sont l’âme de la Côte d’Ivoire »",
        date: "juin 24, 2024",
        heure: "12:58 am",
        description: "Les lampions se sont éteints ce Lundi 07 Août sur l’édition 2023 de la Semaine Internationale de l’Artisanat de Grand – Bassam, organisée par la Fondation SIAB.",
        image: "/images/actualites/flash-infos/siab/accueil.png",
        slug: "siab",
    },
    {
        title: "Initiative CACAO Côte d’Ivoire Tourisme et L’ANAC préparent une convention en vue de renforcer leur partenariat",
        date: "juin 24, 2024",
        heure: "12:58 am",
        description: " Le Directeur Général de l’Office National du Tourisme, Mme Malékah MOURAD – CONDE a pris part ce 28 Novembre à une rencontre qui vise une meilleure synergie d’action avec l’ Autorité Nationale ",
        image: "/images/actualites/flash-infos/initiative-cacao-anac/accueil.png",
        slug: "initiative-cacao-anac",
    },
    {
        title: "Initiative CACAO",
        date: "juin 24, 2024",
        heure: "12:58 am",
        description: "La 1ère édition du World Chocolate Initiative Competition s’est déroulée du 02 au 05 novembre 2023 au Bushman Café à Abidjan. Pour Madame Malékah Mourad-Condé, Directeur Général de Côte d’Ivoire",
        image: "/images/actualites/flash-infos/initiative-cacao/accueil.png",
        slug: "initiative-cacao",
    },
    {
        title: "IFTM TOP RESA 2023: Côte d'Ivoire Tourisme au Rendez-vous de la Grande Messe",
        date: "3 Octobre 2023",
        heure: "",
        description:
            "Ce mardi 03 Octobre 2023, Olivia Grégoire Ministre Français délégué au Tourisme a donné le Top départ de la 45ème édition du Top Résa 2023 à la Porte de Versailles à Paris. Côte d'Ivoire Tourisme a effectué le déplacement à ce grand rendez-vous du Tourisme.",
        image: "/images/actualites/foires-et-salons/iftm/gallerie/1.jpeg",
        slug: "iftm",
    },
];
